// extracted by mini-css-extract-plugin
export var linkText = "_r9-0";